import React, { useState } from 'react';
import styles from './StatusPageView.module.less';
import StatusPageTable from './StatusPageTable';
import TotalWorkUnits from './TotalWorkUnits/TotalWorkUnits';
import { Col, Row } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/pro-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import StatusWUFilter from './StatusWUFilter';
import WorkUnitScriptFilter from './WorkUnitScriptFilter/WorkUnitScriptFilter';
import WorkUnitPriorityFilter from './WorkUnitPriorityFilter';

const faSyncAltPropIcon = faSyncAlt as IconProp;
type StatusPageViewProps = {
  runId: string | null;
};
const StatusPageView: React.FC<StatusPageViewProps> = ({ runId}) => {
  const [isReset, setReset] = useState(false);
  const [status, setStatus] = useState<string>('');
  const [priority, setPriority] = useState<string>('');
  const [script, setScript] = useState<string>('');
  const onReset = () => {
    setReset(true);
    setPriority('');
    setStatus('');
    setScript('');
  };
  return (
    <>
      <h1 className={styles.statusPageTitle}>Status Page</h1>
      <div>
        <Row className="box" style={{ marginBottom: '24px' }}>
          <Col span={24} className="gutter-row">
            <TotalWorkUnits runId={runId} />
          </Col>
        </Row>
      </div>
      <div className={styles.statusFilters}>
        <WorkUnitScriptFilter isReset={isReset} setReset={setReset} onScriptUpdate={setScript} runId={runId} />
        <StatusWUFilter isReset={isReset} setReset={setReset} onStatusUpdate={setStatus} />
        <WorkUnitPriorityFilter isReset={isReset} setReset={setReset} onPriorityUpdate={setPriority} />
        <FontAwesomeIcon
          title={'Reset Filters'}
          icon={faSyncAltPropIcon}
          className={styles.refreshIcon}
          size={'lg'}
          onClick={onReset}
        />
      </div>

      <StatusPageTable runId={runId} status={status} priority={priority} script={script} />
    </>
  );
};
export default StatusPageView;
